<template>
  <div class="">
    <el-dialog
      class="popup-edit"
      classContent="popup-example"
      title="Edit Details"
      :visible.sync="editPopup"
    >
      <EditUserData :editData="editData" @closePopup="closePopup" />
    </el-dialog>
    <div class="">
      <div class="p-2 bordb">
        <h2 class="text-2xl text-black">User Management</h2>
      </div>
      <div class="">
        <el-table
          :data="users"
          border
          style="width: 100%"
          height="490"
          class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
          header-row-class-name="thead-light table-th-color"
        >
          <!-- <el-table-column prop="city" label="Profile" min-width="100px">
            <template slot-scope="">
              <img
                src="https://nimbuscluster.blob.core.windows.net/server01/Brained/Admin/plus3.svg"
                class="object-contain bg-olpink p-3 rounded-full w-12 h-12"
                alt="banh"
              />
            </template>
          </el-table-column> -->
          <el-table-column
            :index="indexmethod"
            type="index"
            label="Sr.no"
            width="80"
          ></el-table-column>
          <el-table-column prop="name" label="Name" min-width="160px">
            <template slot-scope="scope">
              <p class="text-gray text-center">
                {{
                  scope.row.name
                    ? scope.row.name
                    : scope.row.firstName && scope.row.lastName
                    ? `${scope.row.firstName} ${scope.row.lastName}`
                    : "-"
                }}
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="role" label="Role" min-width="160px">
            <template slot-scope="scope">
              <p class="text-gray text-center">
                {{ scope.row.role ? scope.row.role : "-" }}
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="mobile" label="Phone" min-width="170px">
            <!-- <template slot-scope="">
              <P class="text-gray">+91 8779030555</P>
            </template> -->
          </el-table-column>
          <el-table-column prop="email" label="Email" min-width="170px">
            <!-- <template slot-scope="">
              <P class="text-gray">abcd@gmail.com</P>
            </template> -->
          </el-table-column>

          <el-table-column prop="city" label="Actions" min-width="140px">
            <template v-slot="{ row }">
              <div class="flex gap-1 items-center">
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-4 h-4"
                  class="cursor-pointer"
                  @click="edit(row)"
                />
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="w-full flex justify-end mt-6">
          <el-pagination
            @current-change="
              (value) => {
                currentPage = value;
                getAllUsers();
              }
            "
            :per-size="perPage"
            :total="totalUsers"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EditUserData from "./EditUserData.vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      drawer: false,
      drawer2: false,
      activeName: "first",
      centerDialogVisibleg: false,
      centerDialogVisiblef: false,
      currentPage: 1,
      perPage: 10,
      totalUsers: 0,
      editPopup: false,
      editData: {},
    };
  },

  components: {
    EditUserData,
  },

  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },

    async getAllUsers() {
      try {
        const data = await this.$store.dispatch("user/getAllUsers", {
          perPage: this.perPage,
          page: this.currentPage,
        });
        // console.log(data, "USERS");
        // this.perPage =
        this.totalUsers = data.registeredUserLength;
        // this.$store.commit(
        //   "manageUser/GET_ALL_USER_DETAILS",
        //   data.registeredUser
        // );
        // this.users = data.registeredUser;
      } catch (error) {
        console.log(error);
      }
    },

    edit(item) {
      this.editData = { ...item };
      this.editPopup = true;
    },
    indexmethod(index) {
      if (this.currentPage > 1) {
        let value = (this.currentPage - 1) * 10;
        return index + value + 1;
      } else {
        return index + 1;
      }
    },
    async closePopup() {
      this.editPopup = false;
      await this.getAllUsers();
    },
  },

  computed: {
    ...mapState("user", ["users"]),
  },

  mounted() {
    this.getAllUsers();
  },
};
</script>
